module.exports = __webpack_public_path__ + "static/media/intro-photowall-7.e8264d68.jpg";